import type { Components, Theme } from '@mui/material';

export const linkCustomizations: Components<Theme> = {
  MuiLink: {
    defaultProps: {
      underline: 'always',
      color: 'inherit',
    },
    styleOverrides: {
      root: {
        fontSize: 16,
        fontWeight: 500,
      },
    },
  },
};
